//Reset data
export const RESET = "CONVERSATION_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CONVERSATION_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CONVERSATION_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CONVERSATION_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CONVERSATION_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "CONVERSATION_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CONVERSATION_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CONVERSATION_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CONVERSATION_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CONVERSATION_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CONVERSATION_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "CONVERSATION_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CONVERSATION_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CONVERSATION_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CONVERSATION_SHOW_SET_HIDE_MODAL"


